import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, BaseComponent, User, UserInfo, RiepilogoScrivaniaStatus, PrenotazioneScrivaniaRequest, Prenotazione } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { UfficioService } from '../service/ufficio.service';
import { UserService } from '../service/user.service';
import { AppConstants } from '../core/app.constants';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-detail-scrivanie',
  templateUrl: './scrivania-detail.component.html',
  styleUrls: ['././scrivania-detail.component.css'],
  host: { '(window:keydown)': 'shortcutHandler($event)' }
})
export class DetailScrivaniaComponent extends BaseComponent implements OnInit 
{
    static DIALOG_ID_PRENOTA: string = "insertPrenotazioneDialog";
    static DIALOG_ID_LIBERA: string = "cancellaPrenotazioneDialog";
    @Output() completeAction = new EventEmitter<number>();
    it: any = AppConstants.ITA_CALENDAR_CONF;
    userContext: UserContext;
    userInfo: UserInfo = new UserInfo();
    users: User[] = [];
    currentUserId: number;

    infoMessage: string;
    errorMessage: string;
    
    userSelected: SelectItem = null;
    filterUsers: SelectItem[] = [];
    filteredUsers: SelectItem[] = [];
    
    
    tipoItems: SelectItem[] = [];
    tipoSelected: any = null;
    disableTipoSelected:boolean;

    fromDate: Date = null;
    toDate: Date = null;

    selectedDate: Date = null; // se arrivo dalla selezione di una specifica data
    selectedStatoScrivania: RiepilogoScrivaniaStatus = null;
    prenotazioneScrivania: Prenotazione = null;
    liberaDaUserDefault:boolean;
    liberaDaUserEsterno:boolean;


    private pattern: string = "yyyy-MM-dd";
    
   constructor(protected authAccess: AuthAccessProvider, 
            protected router: Router,
            protected messageProvider: MessageProvider, 
            private ufficioService: UfficioService,
            private userService: UserService,
            private datePipe: DatePipe) {
        super(authAccess, router, messageProvider);
    }
    
  ngOnInit() {
      this.userContext = this.authAccess.getUserContext();
      if(this.userContext == null) {    
          this.authAccess.invalidate();
      } else {
          
          this.init();
          
          let obs: Observable<any>[] = [];
          obs.push(this.userService.currentUserInfo(this.userContext.srmToken));
          obs.push(this.userService.getUsers(this.userContext.srmToken, true, false));
          Observable.forkJoin(obs).subscribe(
              results => {
                  this.userInfo = results[0];
                  this.users = results[1].users;
                  
                  for(var i = 0; i < this.users.length; ++i) {
                      var current: User = this.users[i];
                      var username = current.username.toLowerCase();
                      if (this.userInfo.admin || username == this.userContext.userId.toLowerCase() || this.userInfo.managedUsers.includes(username)) {
                          this.filterUsers.push({label:current.fullname, value: current.id});
                      }
                      if (username == this.userContext.userId.toLowerCase()) {
                          this.currentUserId = current.id;
                      }
                  }
              },
              error => {
                  this.handleError(error);
              }
          );

          this.ufficioService.getScrivaniaDetailStatus().subscribe(
            operation => {
                if (operation.status == "open") {
                    this.errorMessage = null;
                    this.infoMessage = null;
                    this.selectedDate = operation.date;
                    this.selectedStatoScrivania = operation.stato;
                    if (this.selectedDate != null && this.selectedStatoScrivania != null) {
                        this.fromDate = this.selectedDate; 
                        this.toDate   = this.selectedDate;
                        this.reset(false);
                    } else {
                        this.reset(true);
                    }

                    this.logica(operation.stato, operation.prenotazione);
                }
            }
          );
          
      }
  }

  private init() {
    this.reset(true);
    this.tipoItems.push({label: "Intera", value: "F"});
    this.tipoItems.push({label: "Mattina", value: "M"});
    this.tipoItems.push({label: "Pomeriggio", value: "P"});

    this.liberaDaUserDefault = false;
    this.liberaDaUserEsterno = false;
  }

  logica(stato:RiepilogoScrivaniaStatus, prenotazione:Prenotazione){
    if(stato.disponibile){
        //Faccio inserimento di qualsiasi tipo
        $("#" + DetailScrivaniaComponent.DIALOG_ID_PRENOTA).modal({backdrop: 'static', keyboard: false});
    }else if(!prenotazione && stato.listPrenotazioni != null && stato.listPrenotazioni.length == 1){
        //Faccio inserimento del tipo mancante
        let _prenotazione = stato.listPrenotazioni[0];
        let tipo = "M";
        if(_prenotazione.tipo == "M")
            tipo = "P";
        this.tipoSelected = tipo;
        this.disableTipoSelected = true;
        this.prenotazioneScrivania = _prenotazione;
        $("#" + DetailScrivaniaComponent.DIALOG_ID_PRENOTA).modal({backdrop: 'static', keyboard: false});
    }else{
        let _prenotazione = prenotazione;
        if(!_prenotazione && stato.listPrenotazioni != null && stato.listPrenotazioni.length > 0)
            _prenotazione = stato.listPrenotazioni[0];
        this.prenotazioneScrivania = _prenotazione;
        let tipo = this.tipoItems[0].value;
        if(_prenotazione)
            tipo = _prenotazione.tipo;
        //Posso solo togliere le prenotazioni
        if(stato.scrivania.liberaDalDefault){
            if(stato.listPrenotazioni != null && stato.listPrenotazioni.length > 0){
               
                if(this.userInfo.admin || this.userInPrenotazioni(this.userContext.userId, stato) || (this.userInfo.managedUsers != null && this.userInfo.managedUsers.includes(_prenotazione.nomeUser.toLowerCase()))){
                    this.userSelected = this.returnUser(_prenotazione.idUser);
                    this.tipoSelected = this.returnTipoItem(_prenotazione.tipo);
                    this.liberaDaUserEsterno = true;
                    $("#" + DetailScrivaniaComponent.DIALOG_ID_LIBERA).modal({backdrop: 'static', keyboard: false});
                }else{
                    //TOAST di errore TODO
                }
            }
        }else{

          if(this.userInfo.admin || this.userContext.userId.toLowerCase() == stato.scrivania.userName.toLowerCase() || (this.userInfo.managedUsers != null && this.userInfo.managedUsers.includes(stato.scrivania.userName.toLowerCase()))){
           
            this.userSelected = this.returnUser(stato.scrivania.idUserDefault);
            this.tipoSelected = tipo;
            this.liberaDaUserDefault = true;
            $("#" + DetailScrivaniaComponent.DIALOG_ID_LIBERA).modal({backdrop: 'static', keyboard: false});
          }else{
            //toast di errore TODO
          }
        }
        
    }
  }

  returnTipoItem(tipo:string){
    if(tipo == "F"){
        return this.tipoItems[0].value
    }else if(tipo == "M"){
        return this.tipoItems[1].value
    }else if(tipo == "P"){
        return this.tipoItems[2].value
    }
    return this.tipoItems[0].value
  }

  returnUser(u:number){
    let result:SelectItem = null;
    for(let i = 0; i < this.filterUsers.length; i++) {
        let item = this.filterUsers[i];
        if(item.value == u){
            result = item;
            return result;
        }
    }
    return result;
  }

  userInPrenotazioni(user:string, stato:RiepilogoScrivaniaStatus){
    for(var i = 0; i < stato.listPrenotazioni.length; i++) {
        if(stato.listPrenotazioni[i].nomeUser.toLowerCase() == user.toLowerCase()){
            return true;
        }
    }
    return false;
  }

  prenota(){
    this.infoMessage = null;
    this.errorMessage = null;
    
    if (this.fromDate > this.toDate) {
        this.errorMessage = "Data di fine periodo antecedente alla data di inizio";
        return;
    }

    let request:PrenotazioneScrivaniaRequest = new PrenotazioneScrivaniaRequest();
    request.dataDa = this.datePipe.transform(this.fromDate, this.pattern);
    request.dataA =  this.datePipe.transform(this.toDate, this.pattern);
    request.idScrivania = this.selectedStatoScrivania.scrivania.idScrivania;
    request.idUtente = this.userSelected != null ? this.userSelected.value : null;
    request.occupa = true;
    request.tipo = this.tipoSelected;
    this.ufficioService.prenotaScrivania(this.userContext.srmToken, request).subscribe(
        result => {
            let msg = "Inserimento eseguito correttamente";
            
            this.messageProvider.notifyMessage(msg);
            this.closePrenota();
           
            this.ufficioService.fireRefreshEvent();
        },
        error => {
            this.errorMessage = this.retrieveError(error);
        }
    )
  }

  cancellaPrenotazione(){
    this.infoMessage = null;
    this.errorMessage = null;

    if(this.fromDate == null){
        this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
        return;
    }
    if(this.selectedStatoScrivania == null){
        this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
        return;
    }


    if(this.liberaDaUserDefault){
        let request:PrenotazioneScrivaniaRequest = new PrenotazioneScrivaniaRequest();
        request.dataDa = this.datePipe.transform(this.fromDate, this.pattern);
        request.dataA =  this.datePipe.transform(this.fromDate, this.pattern);
        request.idScrivania = this.selectedStatoScrivania.scrivania.idScrivania;
        request.idUtente = this.selectedStatoScrivania.scrivania.idUserDefault;
        request.occupa = false;
        request.tipo = "F";
        this.ufficioService.prenotaScrivania(this.userContext.srmToken, request).subscribe(
            result => {
                let msg = "Liberazione scrivania eseguita correttamente";
                
                this.messageProvider.notifyMessage(msg);
                this.closeCancella();
                this.ufficioService.fireRefreshEvent();
            },
            error => {
                this.errorMessage = this.retrieveError(error);
            }
        )
    }else if(this.liberaDaUserEsterno){
        if(this.selectedStatoScrivania.listPrenotazioni != null && this.selectedStatoScrivania.listPrenotazioni.length > 0){
            this.ufficioService.liberaScrivania(this.userContext.srmToken, this.prenotazioneScrivania.idPrenotazione).subscribe(
                result => {
                    let msg = "Liberazione scrivania eseguita correttamente";
                    
                    this.messageProvider.notifyMessage(msg);
                    this.closeCancella();
                    this.ufficioService.fireRefreshEvent();
                },
                error => {
                    this.errorMessage = this.retrieveError(error);
                }
            )
        }else{
            this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
            return;
        }


        
    }else{
        this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
        return;
    }
  }
  
  reset(full: boolean) {
    if (full) {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.selectedStatoScrivania = null;
        this.liberaDaUserDefault = false;
        this.liberaDaUserEsterno = false;
    }
    this.prenotazioneScrivania = null;
    this.userSelected = null;
    this.disableTipoSelected = false;
    if (this.tipoItems.length > 0) {
        this.tipoSelected = this.tipoItems[0].value;
    }
    this.errorMessage = null;
    this.infoMessage = null;
  }
  
  filterUser(event) {
    this.filteredUsers = AppConstants.filterSuggestions(this.filterUsers, event.query, item => [item.label]);
  }
  
  changeDateStart() { 
    if (this.fromDate > this.toDate) {
        this.toDate = this.fromDate;
    }
  }
  
  closePrenota() {
    this.completeAction.emit(1);
    $("#" + DetailScrivaniaComponent.DIALOG_ID_PRENOTA).modal("hide");

  }

  closeCancella(){
    this.reset(true);
    this.completeAction.emit(2);
    $("#" + DetailScrivaniaComponent.DIALOG_ID_LIBERA).modal("hide");
  }
  
  shortcutHandler(event) { 
    if (event.keyCode == 27) { // ESC
        this.closePrenota();
        this.closeCancella();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/scrivania-detail/scrivania-detail.component.ts